/*
 * flashmeeting-be
 *
 * Author: Andgel BRISSAUD
 * Copyright (c) 2024 Prodeo - All Rights Reserved
 */

/* ===== enum for KpiSpec ===== */
export enum eKpiSpec {
  FIRST = 1,
  EVENT_MANAGER = FIRST,
  SECTOR,
  SECTORS,
  SITE,
  SITES,
  LAST = SITES,
  NUMBER = LAST - FIRST + 1
}

export enum eKpiLateDayRange {
  FIRST = 1,
  ONE_TO_SIX = FIRST,
  SEVEN_TO_THIRTEEN,
  FOURTEEN_TO_TWENTY,
  TWENTY_ONE_TO_TWENTY_SEVEN,
  TWENTY_EIGHT_TO_THIRTY_FOUR,
  THIRTY_FIVE_PLUS,
  LAST = THIRTY_FIVE_PLUS,
  NUMBER = LAST - FIRST + 1
}